import React from 'react'

import Section from '../../../react4xp/components/Section'
import FAQ from '../../../react4xp/components/FAQ'

function FaqPart(props) {
	const {
		title,
		intro,
		faq
	} = props
    return (
		<Section>
			<FAQ
				title={title}
				intro={intro}
				faq={faq}
			/>
		</Section>
        
    )
}

export default (props) => <FaqPart {...props} />
